
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { VERIFY_SUCCESS, VERIFY_FAIL, CREATE_CART_SUCCESS } from '../redux/actionTypes';
import { apiService } from '../services/service';
import Loader from 'components/loader';
import React from 'react';  

export default function OAuthCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loading, setLoading] = React.useState(false);

useEffect(() => {
  let isMounted = true; // guard against state updates if unmounted

  const handleOAuth = async () => {
    const code = await params.get('code');
    console.log("OAuth code:", code);

    if (!code) {
      navigate('/login');
      return;
    }

    try {
      const data = await apiService.post({
        url: '/auth/google_token/callback',
        payload: { code, redirect_uri: `${window.location.origin}/oauth-callback` }
      });
      setLoading(true)
      if (!isMounted) return; // prevent updates if unmounted
      if (data){
        setLoading(false)
      const { access_token, refresh_token, user, active_quote_id } = data;

      if (access_token && refresh_token) {
        localStorage.setItem('access_token', JSON.stringify(access_token));
        localStorage.setItem('refresh_token', JSON.stringify(refresh_token));
        localStorage.setItem('token', JSON.stringify(access_token));
        dispatch({ type: VERIFY_SUCCESS, payload: { status: 'success', data, user } });

        if (active_quote_id) {
          dispatch({ type: CREATE_CART_SUCCESS, payload: active_quote_id });
        }

        toast.success('Logged in with Google!', { position: 'top-right' });
        navigate('/dashboard');
      } else {
        throw new Error('No tokens received');
      }
    }
    } catch (err) {
      if (!isMounted) return;
      console.error('Google login error:', err);
      dispatch({ type: VERIFY_FAIL, error: err.message });
      toast.error('Google login failed', { position: 'top-right' });
      navigate('/login');
    }
  };

  handleOAuth();

  // ✅ cleanup function (React expects this)
  return () => {
    isMounted = false;
  };
}, [dispatch, navigate, params]);

if (loading) {
  return <Loader />;
}
}
// ...existing code...
